import { Form, FormRule } from "antd";
import { NamePath } from "antd/es/form/interface";
import * as React from "react";
import { SelectValueCatalogId } from "src/business/valueCatalog/SelectValueCatalog";
import { $ZodType } from "zod/v4/core";

import { FieldDef, itemName, makeLabel } from "../attrMetaEditorUtils";

type PropsMetaSelectValueCatalogId = {
  node: $ZodType;
  path: NamePath;
  field?: FieldDef;
};

export const MetaSelectValueCatalogId: React.FC<
  PropsMetaSelectValueCatalogId
> = (props) => {
  const { node, path, field } = props;
  const rules: FormRule[] = [];
  if (!field?.optional) {
    rules.push({
      required: true,
      message: "Необходимо выбрать каталог значений",
    });
  }
  return (
    <Form.Item
      name={itemName(path)}
      label={makeLabel(node, path, field)}
      rules={rules}
    >
      <SelectValueCatalogId />
    </Form.Item>
  );
};
